import { palette } from '@shipium-corp/shipium-ui-theme';
import { Row, Col, Card, Space, Statistic, Typography } from 'antd';
import { SimulationCard } from '../../../pages/Simulation/SimulationCard';
import type { MarginSimulationReportData } from '../../../store/simulation/types';
const { Title } = Typography;
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export interface SimulationMarginReportMarginTotalsRowProps {
  reportData: MarginSimulationReportData;
  loading: boolean;
}

export const SimulationMarginReportMarginTotalsRow = ({
  reportData,
  loading,
}: SimulationMarginReportMarginTotalsRowProps) => (
  <SimulationCard subHeading="Total counts and costs for this simulation" heading="Summary Totals">
    <Row style={{ marginBottom: 10 }} gutter={16}>
      <Col span={8}>
        <Card loading={loading} bordered={true} style={{ height: '100%', background: '#fafafa' }}>
          <Title level={4}>Total Shipments</Title>
          <Space size={'large'}>
            <Statistic
              title={'Simulated'}
              value={reportData?.totalSimulationLabelCount}
              precision={0}
              valueStyle={{ color: palette.Grey.dark }}
            />
          </Space>
        </Card>
      </Col>
      <Col span={8}>
        <Card loading={loading} bordered={true} style={{ height: '100%', background: '#fafafa' }}>
          <Title level={4}>Total Simulation Sell Rate Price</Title>
          <Space size={'large'}>
            <Statistic
              title={'Simulated'}
              value={currencyFormatter.format(reportData?.totalSimulationSellRateSurchargeCost)}
              precision={0}
              valueStyle={{ color: palette.Grey.dark }}
            />
          </Space>
        </Card>
      </Col>
      <Col span={8}>
        <Card loading={loading} bordered={true} style={{ height: '100%', background: '#fafafa' }}>
          <Title level={4}>Total Simulation Sell Rate Price (without surcharges)</Title>
          <Space size={'large'}>
            <Statistic
              title={'Simulated'}
              value={currencyFormatter.format(reportData?.totalSimulationSellRateBaseCost)}
              precision={0}
              valueStyle={{ color: palette.Grey.dark }}
            />
          </Space>
        </Card>
      </Col>
      {reportData?.totalHistoricalCost > 0 && (
        <Col span={8}>
          <Card loading={loading} bordered={true} style={{ height: '100%', background: '#fafafa' }}>
            <Title level={4}>Total Historical Label Cost</Title>
            <Space size={'large'}>
              <Statistic
                title={'Historical'}
                value={currencyFormatter.format(reportData?.totalHistoricalCost)}
                precision={0}
                valueStyle={{ color: palette.Grey.dark }}
              />
            </Space>
          </Card>
        </Col>
      )}
    </Row>
  </SimulationCard>
);
